import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import CreateRFI from "./pages/CreateRFI";
import Rfi from "./pages/Rfi";
import AppLayout from "./components/AppLayout";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";
import useInitProfile from "./hooks/useInitProfile";
import Fabrication from "./pages/Fabrication";
import { Toaster } from "react-hot-toast";
import { toastConfig } from "./utils/toast";
import PaintingChecklistPage from "./pages/PaintingChecklistPage";
import DCUploadDocuments from "./pages/DCUploadDocuments";
// import ReportWithAdvancedPdf from "./components/Reports/Report";

function App() {
  useInitProfile();

  return (
    <Router>
      <Toaster {...toastConfig} />

      <Routes>
        {/* Public Routes */}
        <Route path="/login" element={<Login />} />
        <Route path="/password/forgot" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />

        {/* Protected Routes with Permission-based Access */}

        {/* Dashboard - Available to all authenticated users with dashboard permission */}
        <Route element={<ProtectedRoute requiredPermission="dashboard" />}>
          <Route
            path="/dashboard"
            element={
              <AppLayout>
                <Dashboard />
              </AppLayout>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Route>

        {/* View RFI - For users with view_rfi permission */}
        <Route element={<ProtectedRoute requiredPermission="view_rfi" />}>
          <Route
            path="/viewRFI/:rfinumber"
            element={
              <AppLayout>
                <Rfi />
              </AppLayout>
            }
          />
        </Route>

        {/* RFI Document - For users with rfi_document permission */}
        <Route element={<ProtectedRoute requiredPermission="rfi_document" />}>
          <Route
            path="/rfi_document/:rfinumber"
            element={
              <AppLayout>
                <DCUploadDocuments />
              </AppLayout>
            }
          />
        </Route>

        {/* Create RFI - For users with create_rfi permission */}
        {/* Even if current user doesn't have this permission, keep the route */}
        <Route element={<ProtectedRoute requiredPermission="create_rfi" />}>
          <Route
            path="/createRFI"
            element={
              <AppLayout>
                <CreateRFI />
              </AppLayout>
            }
          />
        </Route>

        {/* Fabrication - For users with fabrication permission */}
        <Route element={<ProtectedRoute requiredPermission="fabrication" />}>
          <Route
            path="/templates/fabrication"
            element={
              <AppLayout>
                <Fabrication />
              </AppLayout>
            }
          />
        </Route>

        {/* Painting checklist - For users with painting_checklist permission */}
        <Route
          element={<ProtectedRoute requiredPermission="painting_checklist" />}
        >
          <Route
            path="/templates/painting-checklist"
            element={
              <AppLayout>
                <PaintingChecklistPage />
              </AppLayout>
            }
          />
        </Route>

        {/* report page template creation */}
        {/* <Route>
          <Route
            path="/report"
            element={
              <AppLayout>
                <ReportWithAdvancedPdf />
              </AppLayout>
            }
          />
        </Route> */}

        {/* Fallback route */}
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
